import { useQuery } from "react-query";
import { Box, Button, Stack } from "@mui/material";
import Popup from "../Modal";
import fetcher from "../../../dataProvider";

const REFETCH_INTERVAL = 1000 * 60; // 1 minute
type GetExamVacantSeatResponse = { remainingSeat: number };

export const getExamVacantSeat = async (venueExamGuid: string) => {
  const response = await fetcher.get(
    `/api/getExamVacantSeat?venueExamGuid=${venueExamGuid}`
  );
  return response.data as GetExamVacantSeatResponse;
};

export const getNoSlotsMsg = (pageText: any): string =>
  pageText?.messagesMetadata?.noSlotAvailable ??
  "Sorry, there are currently no seats remaining for the chosen Test Date and Venue.";

export const NoSlotsChecker = ({
  pageText,
  venueExamGuid,
  toggleSteps,
}: {
  pageText: any;
  venueExamGuid?: string;
  toggleSteps: Function;
}) => {
  const { data, isSuccess } = useQuery({
    queryKey: ["getExamVacantSeat", venueExamGuid],
    queryFn: () => getExamVacantSeat(venueExamGuid!),
    refetchInterval: REFETCH_INTERVAL,
    enabled: !!venueExamGuid,
  });

  const open = isSuccess && !!data && data.remainingSeat <= 0;

  const handleClose = () => {
    toggleSteps("examDetails", 1);
  };

  return (
    <Popup open={open} handleClose={handleClose}>
      <Box
        sx={{
          borderRadius: "8px",
          background: "#F0FCF8",
          padding: "16px",
          marginBottom: "28px",
        }}
      >
        {getNoSlotsMsg(pageText)}
      </Box>
      <Stack direction="row" justifyContent="center" gap={2}>
        <Button variant="outlined" onClick={handleClose}>
          {pageText?.buttonsMetadata?.okButtonText}
        </Button>
      </Stack>
    </Popup>
  );
};
